import React from 'react';
import { Modal } from '../ui/Modal';

const STEPS = [
  'Two companies appear side by side with a financial metric.',
  'Tap the company you think has the higher value.',
  'Answer before the timer runs out. Correct answers extend your streak.',
  'One wrong answer ends the game. How far can you go?',
];

interface RushHowToPlayProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RushHowToPlay: React.FC<RushHowToPlayProps> = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="How to Play" className="max-w-sm">
      <ol className="space-y-5">
        {STEPS.map((text, i) => (
          <li key={i} className="flex gap-4 items-start">
            <span
              className="flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold text-white"
              style={{
                background: 'linear-gradient(135deg, var(--rush-purple-mid), var(--rush-purple-accent))',
                boxShadow: '0 0 12px var(--rush-purple-glow)',
              }}
            >
              {i + 1}
            </span>
            <span className="text-sm leading-relaxed" style={{ color: 'hsl(var(--foreground))' }}>
              {text}
            </span>
          </li>
        ))}
      </ol>
    </Modal>
  );
};
